import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import MyIcon from '../../../components/general/icon'
import MessageRibbon from './ribbon'
import MessageDetail from './detail'
import DeleteMessage from './delete'

export default function Message() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [messageData, setMessageData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const [isDeleteVisible, setIsDeleteVisible] = useState(false)

  const initialConditions = {
      status: 0,
      keywords: ''
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getMessageData = () => {
    axios.post('/p/content/message/list/get', {
      merchant_oid: merchantOid,
      status: filterValue.status,
      keywords: filterValue.keywords,
      page: currentPage,
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMessageData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'messages': response.data.messages
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getMessageData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 1) return 'green'
    return 'orange'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteMessage = (oid, content) => {
    setIsDeleteVisible(true)
    setPropsData({ oid: oid, content: content })
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">留言管理</div>
          <MessageRibbon
            filterValue={filterValue}
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>留言用户</th>
                <th>留言内容</th>
                <th>联系方式</th>
                <th>状态</th>
                <th>留言时间</th>
                <th style={{width: '50px'}}></th>
              </tr>
            </thead>

            <tbody>
              {messageData.messages && (messageData.messages.length > 0 ? (messageData.messages.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.consumer_nickname}</td>
                  <td style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{item.content}</td>
                  <td>{item.contact || '未填写'}</td>
                  <td style={{ color: getColor(item.status) }}>{item.status_value}</td>
                  <td>{item.create_time}</td>
                  <td>
                    <div style={{display: 'flex', justifyContent: 'center', cursor: 'pointer', color: '#ae2a19'}}
                      onClick={(event) => {event.stopPropagation(); deleteMessage(item.oid, item.content)}}>
                      <MyIcon name='huishouzhan' />
                    </div>
                  </td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="6"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination
            current={currentPage}
            total={messageData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <MessageDetail
          data={propsData}
          isOpen={isDetailVisible}
          getMessageData={getMessageData}
          deleteMessage={deleteMessage}
          isCancel={() => { setIsDetailVisible(false) }}
        />}

        {isDeleteVisible && <DeleteMessage
          data={propsData}
          isOpen={isDeleteVisible}
          getMessageData={getMessageData}
          isCancel={() => { setIsDeleteVisible(false) }}
        />}
      </div>
    </div>
  )
}
